module.exports = __webpack_public_path__ + "img/agent-tasks.88073762.webp";